import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Row, Col, Form, Button, InputGroup } from 'react-bootstrap';
import $ from 'jquery';
import { getRequestSubdomain } from '../../utils/tenant';

const ForgotEmail = () => {
  const navigate = useNavigate();
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const DefaultAppId = process.env.REACT_APP_DEFAULT_APP_ID;
  const [whatsappNo, setWhatsappNo] = useState('');
  const [error, setErrorMessage] = useState('');

  const validatePhoneNumber = (number) => {
    const phoneRegex = /^[0-9]{10}$/;
    return phoneRegex.test(number);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validation
    if (!validatePhoneNumber(whatsappNo)) {
      setErrorMessage('Please enter a valid 10-digit WhatsApp number');
      return;
    }

    setErrorMessage(''); // Clear error if any

    const userData = {
      accountVerificationType: 2,
      whatsAppNo: whatsappNo,
      accountId: DefaultAppId,
      subdomain: getRequestSubdomain(),
    };

    debugger;

    $.ajax({
      url: `${apiBaseUrl}/Auth/forget-email-password`,
      type: 'POST',
      contentType: 'application/json',
      data: JSON.stringify(userData),
      success: function (response) {
        debugger;
        if (response.success && response.data) {
          setErrorMessage('');
          navigate('/verifyotp', {
            state: {
              whatsappNo:whatsappNo,
              actionType:'forgotemail' // or 'changepassword'
            }
          });
        } else {
          setErrorMessage(response.data.errorMessage);
        }
      },
      error: function (response) {
        debugger;
        const errorData = response.responseJSON;

        // Prefer message or errors[0] if available
        let errorMessage = "An error occurred.";

        if (errorData?.message) {
          errorMessage = errorData.message;
        } else if (Array.isArray(errorData?.errors) && errorData.errors.length > 0) {
          errorMessage = errorData.errors[0];
        }

        setErrorMessage(errorMessage);
      }
    });

  };

  const handleInputChange = (e) => {
    const value = e.target.value;
    if (/^\d*$/.test(value)) {
      setWhatsappNo(value);
    }
  };

  return (
    <div className="bg-light py-5">
      <Container className="bg-white rounded shadow p-4">
        <Row className="align-items-center">
          <Col md={6} className="text-center">
            <img
              src='/assets/images/login-illustration.png'
              alt="Login Illustration"
              className="img-fluid rounded mb-3"
              style={{ maxHeight: '300px' }}
            />
            <p className="text-muted fs-5">Let us help you grow..</p>
          </Col>

          <Col md={6}>
            <div className="p-3">
              <h2 className="fw-bold mb-2 d-flex align-items-center gap-2">
                Forgot Email ?
                <img src='/assets/images/logo.png' alt="Logo" width="50" />
              </h2>
              <h6>Let's Verify your identity</h6><br/>
              <p>Enter the phone number associated with your Nurturix account for two step verification</p>
              
              <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3" controlId="WhatsAppNo">
                  <Form.Label>
                    WhatsApp No <span style={{ color: 'red' }}>*</span>
                  </Form.Label>
                  <InputGroup>
                    <InputGroup.Text>+91</InputGroup.Text>
                    <Form.Control
                      type="text"
                      value={whatsappNo}
                      onChange={handleInputChange}
                      maxLength="10"
                      required
                    />
                  </InputGroup>
                  {error && (
                    <div className="text-danger mt-1" style={{ fontSize: '0.9rem' }}>
                      {error}
                    </div>
                  )}
                </Form.Group>

                <Button
                  type="submit"
                  className="w-100 text-white fw-semibold"
                  style={{
                    backgroundColor: '#CC5500',
                    border: 'none',
                  }}
                >
                  Continue
                </Button>
              </Form>

              <p className="mt-3 text-center">
                Don’t have an account? <a href="/signup" className="text-primary">Sign up</a>
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ForgotEmail;
